import { useEffect, useState } from "react";
import { CommandBar, DefaultButton, IButtonProps, ICommandBarItemProps, IDropdownOption} from "@fluentui/react";
import { useHistory } from "react-router-dom";
import { NEED_TO_SUBSCRIBE, DESCRIPTIONS, ANALISIS_CUANTITATIVO_DESCRIPTION } from "./Util/texts";
import UsersSubscriptionService from "../../../services/UsersSubscriptionService";
import Diversificacion from "./Tabs/Diversificacion/Diversificacion";
import AnalisisCuantitativo from "./Tabs/AnalisisCuantitativo/AnalisisCuantitativo";
import Auth from "../../../Auth/Auth";
import SavingsPlanService, { ActiveSubscriptionAndSavingPlans } from "../../../services/SavingsPlanService";
import { TTabType } from "./types/PortfolioTypes";
import Distribucion from "./Tabs/Distribucion/Distribucion";

const BASE_CLASS = "portfolio_file";

const FICHA_CARTERA_SUBSCRIPTION_ID = 52;

const PortfolioFile = () => {
    const user = Auth.getUserProfile();
    const localTheme = window.localStorage.getItem("theme") || "light";

    // DESCRIPTION
    const [description, setDescription] = useState<string>(ANALISIS_CUANTITATIVO_DESCRIPTION);

    // DROPDOWN OPTIONS
    const [options, setOptions] = useState<IDropdownOption[]>([]);

    // SUBSCRIPTION STATUS 
    const [ subscriptionStatus, setSubscriptionStatus ] = useState<boolean>(true); // TODO: Cambiar a false cuando susbscription process esté en marcha
    const [ activeTab, setActiveTab ] = useState<string>('Analisis cuantitativo'); 

    const _overflowItems: ICommandBarItemProps[] = [];
    const overflowProps: IButtonProps = { ariaLabel: 'Más acciones' };

    const history = useHistory();

    const BAR_TABS = [
        {
            text: 'Análisis cuantitativo',
            key: 'analisis',
            onClick: () => setActiveTab('Analisis cuantitativo'),
            className: activeTab === 'Analisis cuantitativo' ? 'is-selected' : '',
        },
        {
            text: 'Diversificación',
            key: 'diversificacion',
            onClick: () => setActiveTab('Diversificacion'),
            className: activeTab === 'Diversificacion' ? 'is-selected' : ''
        },
        {
            text: 'Distribución',
            key: 'distribucion',
            onClick: () => setActiveTab('Distribucion'),
            className: activeTab === 'Distribucion' ? 'is-selected' : ''
        },
    ];

    const updateDescription = () => {
        setDescription(DESCRIPTIONS[activeTab as TTabType] || '');
    };

    const [menuItems, setMenuItems] = useState<ICommandBarItemProps[]>(BAR_TABS);

    useEffect(() => {
        setMenuItems(BAR_TABS);
        updateDescription();
    }, [activeTab])

    const getPlans = async () => {
        const result: ActiveSubscriptionAndSavingPlans[] = await SavingsPlanService.getActiveSubscriptionAndSavingPlan(user.id);
        const aux: IDropdownOption[] = result
            .map(savingsPlan => ({
                key: savingsPlan.finametrixContract,
                text: savingsPlan.planName,
                id: savingsPlan.finametrixId.toString()
            }));
        setOptions(aux);
    }
    const activePlan = Auth.getActivePlan();

    useEffect(() => {
        getPlans();

        // TODO: Descomentarlo cuando susbscription process esté en marcha
        // UsersSubscriptionService.getUsersSubscriptionStatusByUserIdAndSubscriptionId({
        //     userId: user.id,
        //     subscriptionId: FICHA_CARTERA_SUBSCRIPTION_ID,
        // }).then(result => {
        //     setSubscriptionStatus(result.subscriptionStatus.status)
        // })
    }, []);

    return (
        <div className={BASE_CLASS}>

            <div className={`${BASE_CLASS}__header`}>
                <div className={`${BASE_CLASS}__header__texts`}>
                    <h2>Ficha Cartera</h2>
                    <CommandBar
                        // @ts-ignore
                        items={menuItems}
                        overflowItems={_overflowItems}
                        overflowButtonProps={overflowProps}
                        ariaLabel="Usa las flechas izquierda y derecha para navegar entre las entradas del menú"
                    />

                    <p className={`${BASE_CLASS}__header__description ${localTheme}`}>
                        {description}
                    </p>
                    {!subscriptionStatus &&
                    <p className={`${BASE_CLASS}__header__description alert`}>
                        {NEED_TO_SUBSCRIBE}
                    </p>
                    }
                </div>
                <div className={`${BASE_CLASS}__header__buttons`}>
                    {/* TODO: Hay que cambiar el disabled a false cuando el proceso de subscripción esté en marcha */}
                    <DefaultButton className="button tiny-stretch-button" disabled={true} onClick={() => history.push(`/portfolio/service-suscription/${FICHA_CARTERA_SUBSCRIPTION_ID}`)}>
                        Suscribirse
                    </DefaultButton>
                </div>
            </div>
            {subscriptionStatus &&
                <>
                    {activeTab.match("Analisis cuantitativo") && <AnalisisCuantitativo activePlan={activePlan}  options={options} />}
                    {activeTab.match("Diversificacion") && <Diversificacion activePlan={activePlan} options={options} />}
                    {activeTab.match("Distribucion") && <Distribucion activePlan={activePlan} options={options} />}
                </>
                }
            
        </div>
    )
}

export default PortfolioFile;